export default {"src":"/_next/static/media/rupees.f7984716.svg","height":101,"width":101};